import { motion } from 'framer-motion';
import { useState } from 'react';
import Button from '../common/Button';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const links = [
    { name: 'Início', href: '#home' },
    { name: 'Áreas', href: '#areas' },
    { name: 'Procedimentos', href: '#procedimentos' },
    { name: 'Sobre', href: '#sobre' },
    { name: 'FAQ', href: '#faq' },
  ];

  const handleAgendar = () => {
    window.open("https://wa.me/5563991352552?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta.", "_blank");
  };

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="font-serif text-2xl font-bold text-primary">
            Dra. Fernanda<span className="text-textLight">Palhares</span>
          </div>

          <nav className="hidden md:flex space-x-8">
            {links.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-textLight hover:text-primary transition-colors duration-300 font-medium"
              >
                {link.name}
              </a>
            ))}
          </nav>

          <Button onClick={handleAgendar} className="hidden md:inline-flex">
            Agendar Consulta
          </Button>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-primary focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="md:hidden py-4 border-t"
          >
            <nav className="flex flex-col space-y-4">
              {links.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="text-textLight hover:text-primary transition-colors"
                >
                  {link.name}
                </a>
              ))}
              <Button onClick={handleAgendar} className="w-full">
                Agendar Consulta
              </Button>
            </nav>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
};

export default Header;